<div class="timeline-container" *ngFor="let timelineItem of timelineItems; trackBy: trackByIndex">
  <app-timeline-item [timelineItem]="timelineItem" [isChaseTimeline]="isChaseTimeline"></app-timeline-item>
</div>
